import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

// Función para obtener todas las sedes desde Firebase
export const getSedes = async () => {
  const sedesCollection = collection(db, "sedes"); // Ajusta el nombre de la colección
  const snapshot = await getDocs(sedesCollection);
  const sedesList = snapshot.docs.map((doc) => doc.data());
  return sedesList;
};
